var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("Promociones")]),_c('uv-data-table',{attrs:{"config":_vm.config,"data":_vm.dataPromocion,"pageRows":15},on:{"buttonClick":_vm.dtButtonClick,"buttonOptClick":_vm.optButtonClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }